import React from 'react';
import { useDroppable } from '@dnd-kit/core';

export function Droppable(props) {
    const { isOver, setNodeRef } = useDroppable({
        id: props.id,
    });
    
    const style = {
        backgroundColor: isOver ? 'rgba(0, 0, 0, 0.1)' : undefined,
    };

    return (
        <div ref={setNodeRef} style={style} className={props.className}>
            {props.children}
        </div>
    );
}
